import React from "react";
import PropTypes from "prop-types";
import { Controller } from "react-hook-form";
import styled from "styled-components";

import {
  BaseFieldStyle,
  FieldWrapper,
  Label,
  RequiredMark,
  ErrorText,
} from "./SharedFormStyles";

const StyledTextarea = styled.textarea.withConfig({
  shouldForwardProp: (prop) => prop !== "hasError",
})`
  ${BaseFieldStyle}
`;

const FormTextareaField = ({
  name,
  label,
  control,
  error = null,
  placeholder,
  required = false,
  rows = 4,
  disabled = false,
}) => {
  return (
    <FieldWrapper>
      {label && (
        <Label variant="body1" component="label" htmlFor={name}>
          {label} {required && <RequiredMark>*</RequiredMark>}
        </Label>
      )}

      <Controller
        name={name}
        disabled={disabled}
        control={control}
        render={({ field }) => (
          <StyledTextarea
            {...field}
            id={name}
            rows={rows}
            placeholder={placeholder}
            hasError={!!error}
          />
        )}
      />

      {error && <ErrorText variant="body2">{error.message}</ErrorText>}
    </FieldWrapper>
  );
};

// PropTypes
FormTextareaField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  control: PropTypes.object.isRequired,
  error: PropTypes.object,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  rows: PropTypes.number,
  disabled: PropTypes.bool,
};

export default FormTextareaField;
